import { cva } from "class-variance-authority";

export { default as Dot } from "./Dot.vue";

export const variants = cva(["rounded-full", "m-[1px]"], {
    variants: {
        variant: {
            low: ["fg-quinary"],
            normal: ["fg-warning-secondary"],
            high: ["fg-error-secondary"],
            unread: ["fg-success-secondary"],
            read: ["fg-senary"],
            open: ["text-utility-gray-400"],
            scheduled: ["text-utility-blue-light-400"],
            completed: ["text-utility-success-500"],
        },
        size: {
            sm: ["h-1.5", "w-1.5"],
            md: ["h-2", "w-2"],
            lg: ["h-2.5", "w-2.5"],
        },
        defaultVariants: {
            variant: "low",
            size: "sm",
        },
    },
});
